var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtmlIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_712_7711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4061 0H13.0225C5.83036 0 0 5.83036 0 13.0225V38.4061C0 45.5982 5.83036 51.4286 13.0225 51.4286H38.4061C45.5982 51.4286 51.4286 45.5982 51.4286 38.4061V13.0225C51.4286 5.83036 45.5982 0 38.4061 0Z",
    fill: "url(#paint0_linear_712_7711)",
    fillOpacity: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0539 38.0582L11.5713 10.2856H38.8508L36.3656 38.0539L25.1943 41.1428L14.0539 38.0582Z",
    fill: "#E44D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2109 38.6835L34.2617 36.1935L36.3911 12.522H25.2109V38.6835Z",
    fill: "#F16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2108 22.7599H20.7268L20.4171 19.2769H25.2108V15.8755H25.199H16.7139L16.795 16.788L17.6278 26.1612H25.2108V22.7599Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2104 31.7352L25.1957 31.7392L21.4486 30.7017L21.209 27.9502H19.3882H17.8315L18.3029 33.3672L25.1949 35.3291L25.2104 35.3247V31.7352Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2109 22.8071V26.2487H29.3568L28.966 30.7122L25.2109 31.7483V35.3289L32.1131 33.3734L32.1637 32.792L32.9549 23.7313L33.037 22.8071H32.1298H25.2109Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2109 15.8755V17.9586V19.2213V19.2295H33.3932H33.4041L33.4722 18.4756L33.6267 16.7753L33.7078 15.8755H25.2109Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_712_7711",
    x: -20,
    y: -20,
    width: 91.4287,
    height: 91.4287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_712_7711"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_712_7711",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_712_7711",
    x1: 26.3809,
    y1: -8.95808,
    x2: 24.4228,
    y2: 92.8804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FAFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlIcon);
export default __webpack_public_path__ + "static/media/html-icon.79368e5c3db42dfa52804ece697006e4.svg";
export { ForwardRef as ReactComponent };